import React from 'react';
import ReactApexChart from "react-apexcharts";

// Remove dynamic data fetching and use static data directly
const LineColumnArea = ({ salesReportData }) => {
    return (
        <React.Fragment>
            <ReactApexChart
                options={salesReportData?.options}
                series={salesReportData?.series}
                type="line"
                height="350"
                stacked={false}
                className="apex-charts"
            />
        </React.Fragment>
    );
}

export default LineColumnArea;
